import qs from 'qs';
import interceptors from '@/api/supplier/interceptorsSupplier';
import { clientSupplier } from '@/api/supplier/client';

clientSupplier.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function login(username, password) {
    return clientSupplier.post('auth/login', qs.stringify({ platform: 'supplier', username, password }), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
}

export default {
    login,
};